import is from '@sindresorhus/is';

import type { AiTransformationItem } from '../../../data-contract/ai-transformation-strategy';
import type { PositionAutomation, PositionAutomationTask } from '../../../position-management';
import { bandOfExposure } from '../../model/automation';

const byScore = (left: PositionAutomationTask, right: PositionAutomationTask): number => {
    if (is.undefined(left.score) || is.undefined(right.score)) {
        return is.undefined(left.score) ? (is.undefined(right.score) ? 0 : 1) : -1;
    }

    return right.score - left.score;
};

/**
 * A role's or level's tasks, as read for the dashboard, in the shape of a position's task list: highest automation
 * score first, unassessed tasks last. The dashboard's items carry no weekly hours or levers, so those stay empty.
 */
export const roleTaskAutomation = (items: readonly AiTransformationItem[]): PositionAutomation => {
    const tasks = items
        .map(
            (item): PositionAutomationTask => ({
                automatableHoursPerWeek: undefined,
                band: bandOfExposure(item.score),
                hoursPerWeek: undefined,
                id: item.id,
                isAssessmentKnown: !is.nullOrUndefined(item.score),
                levers: [],
                score: item.score ?? undefined,
                title: item.title,
                version: item.taskVersion ?? 0,
            }),
        )
        .sort(byScore);

    return {
        assessedTaskCount: tasks.filter((task) => task.isAssessmentKnown).length,
        band: undefined,
        score: undefined,
        scoreLower: undefined,
        scoreUpper: undefined,
        taskCount: tasks.length,
        tasks,
    };
};
